import { render } from "./AuthenticationCardLogo.vue?vue&type=template&id=71170f8d"
const script = {}

import exportComponent from "/var/www/app/resources/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__